const setItem = (name: string, data: any) => {
    const value = typeof data === "object" ? JSON.stringify(data) : data;
    sessionStorage.setItem(name, value);
  };
  
  const getItem = (name: string, req?: any) => {
    let data;
    if (typeof window !== "undefined") {
      data = sessionStorage.getItem(name);
    }
  
    try {
      return JSON.parse(data);
    } catch {
      return data;
    }
  };
  
  const removeItem = (name) => {
    sessionStorage.removeItem(name);
  };
  
  const removeItems = (...items) =>
    items.forEach((item) => {
      sessionStorage.removeItem(item);
    });
  
  const clearStorage = () => sessionStorage.clear();
  
  const LocalStorage = {
    setItem,
    getItem,
    removeItem,
    removeItems,
    clearStorage,
  };
  
  export default LocalStorage;
  